<template>
  <div>
    <top-title
      class="theTitle"
      :name="name"
      style="min-width: 1046px"
    ></top-title>
    <div class="content-box">
      <div class="tab-line">
        <div
          class="tab-item"
          :class="{ active: tabIndex == 0 }"
          @click="switchTab(0)"
        >
          全部
        </div>
        <div
          class="tab-item"
          :class="{ active: tabIndex == 2 }"
          @click="switchTab(2)"
        >
          系统模板
        </div>
        <div
          class="tab-item"
          :class="{ active: tabIndex == 3 }"
          @click="switchTab(3)"
        >
          自定义模板
        </div>
        <div
          class="tab-item"
          :class="{ active: tabIndex == 1 }"
          @click="switchTab(1)"
        >
          官方模板
        </div>
        <div
          class="tab-item"
          :class="{ active: tabIndex == 4 }"
          @click="switchTab(4)"
        >
          官方模板申请
        </div>
      </div>
       <div class="footTips" style="height: 78px; position: relative" v-if="tabIndex == 4">
        <img
          src="@/assets/images/new_icon_waring_yellow.png"
          style="
            display: inline-block;
            float: left;
            position: absolute;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 1px 4px 0 0;
            top: 9px;
          "
        />
        <span style="margin-left: 18px; line-height: 21px"
          >使用说明：<br>
          1.官方模板审核时间为：每周五16:00-18:00，引用模板之前请提前申请。
          <br>
          2.已经引用的模板无法删除，需关闭相应的任务或替换这些任务的短信模板后，再进行删除操作。</span
        >
      </div>
      <!-- <div class="tip-box" :style="{color: globalBG}" v-if="tabIndex == 4">
        <p>使用说明：</p>
        <p>1.官方模板审核时间为：每周五16:00-18:00，引用模板之前请提前申请。</p>
        <p>2.已经引用的模板无法删除，需关闭相应的任务或替换这些任务的短信模板后，再进行删除操作。</p>
      </div> -->
      <div class="search-box" v-if="tabIndex == 4">
        <el-form
          ref="formSearch"
          :inline="true"
          :model="formData"
          label-width="80px"
        >
          <el-form-item label="模板内容:">
            <el-input
              size="small"
              v-model="formData.content"
              placeholder="请输入模板内容"
              style="margin-right: 80px"
            ></el-input>
          </el-form-item>
          <el-form-item label="模板ID:">
            <el-input
              size="small"
              v-model="formData.officialTemplateId"
              placeholder="请输入模板ID"
              style="margin-right: 80px"
            ></el-input>
          </el-form-item>
          <el-form-item label="审核状态:">
            <el-select v-model="formData.approvalStatus">
              <el-option
                v-for="(item, index) in examineList"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="btn_group">
          <el-button
            size="small"
            :disabled="tableLoading"
            class="search button-status5"
            @click="submitForm('formSearch')"
          >
            <i
              class="el-icon-search"
              style="display: inline-block; width: 14px; height: 12px"
            ></i>
            查询
          </el-button>
          <el-button size="small" class="reset" @click="resetForm"
            >重置</el-button
          >
        </div>
      </div>
      <div class="btn-line" v-if="tabIndex == 3">
        <el-button
          type="primary"
          v-zoom="{ from: pageName, name: '添加栏目' }"
          @click="showAddColumnDialog"
          style="font-size: 14px"
        >
          <img
            src="@/assets/images/member/new_establish.png"
            style="
              display: inline-block;
              float: left;
              width: 14px;
              height: 14px;
              margin-right: 4px;
            "
          />添加栏目
        </el-button>
        <el-button
          class="b1"
          @click="showDelColumnDialog"
          v-zoom="{ from: pageName, name: '删除栏目' }"
          style="font-size: 14px"
          >删除栏目</el-button
        >
        <el-button
          class="b2"
          v-zoom="{ from: pageName, name: '创建模板' }"
          @click="showCreateModuleDialog(1)"
          >创建模板</el-button
        >
      </div>
      <div class="btn-line" style="margin-top: 10px" v-if="tabIndex == 4">
        <el-button
          type="primary"
          v-zoom="{ from: pageName, name: '创建模板' }"
          @click="handleCreateO"
          >创建模板</el-button
        >
      </div>
      <div class="content-table">
        <div class="left-menu">
          <div
            class="menu-item"
            v-for="(item, index) in moduleList"
            :key="index"
          >
            <div
              class="first-menu"
              :class="{ active: selectIndex == index }"
              @click="handleClickFirst(index)"
            >
              <span class="title">
                <template v-if="item.child">
                  <i class="el-icon-caret-right" v-if="!item.isExpand"></i>
                  <i class="el-icon-caret-bottom" v-else></i>
                </template>
                {{ item.title }}
              </span>
            </div>
            <div
              v-if="item.children"
              class="second-menu"
              :style="{
                height: !item.isExpand ? '0' : 28 * item.children.length + 'px',
              }"
            >
              <p
                v-for="(itemSecond, indexSecond) in item.children"
                :class="{ active: selectSecondIndex == indexSecond }"
                :key="indexSecond"
                @click="handleClickFirst(index, indexSecond)"
              >
                {{ itemSecond.title }}
              </p>
              <!-- <p class="active">周年庆</p> -->
            </div>
          </div>
        </div>
        <div class="table-content">
          <el-table
            v-loading="tableLoading"
            tooltip-effect="light"
            :data="tableData"
            :header-cell-style="{ background: '#FAFAFA' }"
          >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column label="模板内容" width="440px">
              <template slot="header" slot-scope="scope">
                <span>模板内容</span>
                <span
                  class="table-message"
                  v-if="!allShow"
                  :style="{ color: '#7f85e9' }"
                  @click="allShow = true"
                  >展开全部</span
                >
                <span
                  class="table-message"
                  v-if="allShow"
                  :style="{ color: '#7f85e9' }"
                  @click="allShow = false"
                  >单行显示</span
                >
              </template>
              <template slot-scope="scope">
                <div v-if="!allShow">
                  <el-popover
                    placement="top-start"
                    width="300"
                    offset="100"
                    trigger="hover"
                    :content="scope.row.content | enVToChinese"
                  >
                    <div class="module-content" slot="reference">
                      {{ scope.row.content | enVToChinese}}
                    </div>
                  </el-popover>
                </div>
                <div v-if="allShow">
                  <div>{{ scope.row.content | enVToChinese}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column key="officialTemplateId" v-if="tabIndex == 4" label="模板ID" prop="officialTemplateId">
            </el-table-column>
            <el-table-column label="字数">
              <template slot-scope="scope">{{
                scope.row.content | enVToChineseLength 
              }}</template>
            </el-table-column>
            <el-table-column key="crtime" v-if="tabIndex == 4" label="创建时间" prop="crtime"></el-table-column>
            <el-table-column v-if="tabIndex != 4" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '0'">自定义模板</span>
                <span v-if="scope.row.type == '1'">系统模板</span>
                <span v-if="scope.row.type == '2'">官方模板</span>
              </template>
            </el-table-column>
             <el-table-column v-if="tabIndex == 4" label="审核状态">
              <template slot-scope="scope">
                <span v-if="scope.row.approvalStatus == '0'">待审核</span>
                <span v-if="scope.row.approvalStatus == '1'">通过</span>
                <span v-if="scope.row.approvalStatus == '2'">拒绝</span>
              </template>
            </el-table-column>
            <el-table-column v-if="tabIndex == 4" label="是否可用">
              <template slot-scope="scope">
                <span v-if="scope.row.status">启用</span>
                <span v-else>禁用</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150px">
              <template slot-scope="scope">
                <div class="operation-btn" v-if="scope.row.type == '0'">
                  <el-button
                    type="text"
                    class="operation"
                    v-zoom="{ from: pageName, name: '修改' }"
                    @click="showCreateModuleDialog(2, scope.row)"
                    >修改</el-button
                  >
                  <el-button
                    type="text"
                    class="operation"
                    v-zoom="{ from: pageName, name: '删除' }"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </div>
                <div class="operation-btn" v-else-if="tabIndex == 4">
                  <el-button
                    type="text"
                    v-if="scope.row.approvalStatus == '1' || scope.row.approvalStatus == '2'"
                    class="operation"
                   
                    v-zoom="{ from: pageName, name: '删除' }"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                  <el-button v-else type="text" :disabled="true">
                    删除
                  </el-button>
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              background
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="form.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalList"
              :current-page="form.current"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加栏目弹窗 -->
    <el-dialog :visible.sync="addColumnDialog" title="添加栏目" width="582px">
      <div class="order-line">
        <span>栏目名称：</span>
        <el-input v-model="title" placeholder="请输入栏目名称"></el-input>
      </div>
      <div class="btn-group">
        <el-button
          :style="{ color: globalBG, 'border-color': globalBG }"
          @click="addColumnDialog = false"
          style="font-size: 14px"
          >取消</el-button
        >
        <el-button
          type="primary"
          style="font-size: 14px"
          @click="handleAddColumn"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 删除栏目 -->
    <el-dialog :visible.sync="delColumnDialog" title="删除栏目" width="430px">
      <div class="order-line">
        <span>选择栏目：</span>
        <el-select style="width: 280px" v-model="delTid">
          <el-option
            v-for="(item, index) in columnList"
            :key="index"
            :label="item.title"
            :value="item.tid"
          ></el-option>
        </el-select>
      </div>
      <div class="btn-group">
        <el-button
          :style="{ color: globalBG, 'border-color': globalBG }"
          style="font-size: 14px"
          @click="delColumnDialog = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          style="font-size: 14px"
          @click="handleDelColumn"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 创建模板 -->
    <el-dialog
      :visible.sync="addModuleDialog"
      :title="addModuleTitle"
      width="582px"
    >
      <div class="order-line">
        <span>短信内容：</span>
        <el-input
          placeholder="请输入短信名称"
          type="textarea"
          v-model="moduleForm.content"
          :autosize="{ minRows: 4, maxRows: 8 }"
        ></el-input>
      </div>
      <div class="order-line" style="margin-top: 16px">
        <span>选择栏目：</span>
        <el-select style="width: 280px" v-model="moduleForm.tid">
          <el-option
            v-for="(item, index) in columnList"
            :key="index"
            :label="item.title"
            :value="item.tid"
          ></el-option>
        </el-select>
      </div>
      <div class="btn-group">
        <el-button
          :style="{ color: globalBG, 'border-color': globalBG }"
          style="font-size: 14px"
          @click="addModuleDialog = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          style="font-size: 14px"
          @click="handleTemplate"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 添加官方申请模板 -->
    <el-dialog :visible.sync="showModuleOffical" title="创建模板" width="582px" :close-on-click-modal="false">
      <el-form :model="moduleOForm" label-width="90px">
        <el-form-item label="选择栏目:" required>
          <el-select
            style="width: 280px"
            v-model="moduleOForm.tid"
            @change="switchOColumn"
          >
            <el-option
              v-for="(item, index) in columnOfficialList"
              :key="index"
              :label="item.title"
              :value="item.tid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="短信变量:">
          <div class="variable-box">
            <div
              class="v-item"
              @click="insertContent(item)"
              :style="{ 'background-color': globalBG }"
              v-for="(item, index) in varilist"
              :key="index"
            >
              {{item | enVToChinese}}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="短信内容:" required>
          <el-input
            placeholder="请输入短信名称"
            id="smsContent"
            type="textarea"
            v-model="moduleOForm.content"
            show-word-limit
            maxlength="200"
            :autosize="{ minRows: 4, maxRows: 8 }"
          ></el-input>
        </el-form-item>
        <el-form-item label="" >
          <div @click="insertX" :style="{ 'background-color': globalBG }" class="insert-dom">插入"回X退订"</div>
        </el-form-item>
      </el-form>
      <div class="btn-group">
        <el-button
          :style="{ color: globalBG, 'border-color': globalBG }"
          style="font-size: 14px"
          @click="showModuleOffical = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          style="font-size: 14px"
          @click="handleOTemplate"
          :disabled="createLoading"
          v-loading="createLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import topTitle from "@/components/top-title.vue";
import {
  getTemplatesPage,
  addCustomerOfficialTemplate,
  getOfficialTemplateDir,
  deleteTemplateDir,
  deleteTemplate,
  delBusApplyTemplate,
  createAddColumn,
  getTemplateDir,
  createTemplate,
  updateTemplate,
  getTemplateChild,
} from "@/api/smsTemplates";
import { mapState, mapMutations } from "vuex";
export default {
  name: "",
  components: {
    topTitle,
  },
  data() {
    return {
      pageName: "后台管理-短信模板",
      name: "短信模板",
      varilist: [],
      examineList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "待审核",
          value: "0",
        },
        {
          label: "通过",
          value: "1",
        },
        {
          label: "拒绝",
          value: "2",
        },
      ],
      formData: {
        content: "",
        officialTemplateId: "",
        approvalStatus: "",
        isBusinessApply: true,
      },
      title: "", // 栏目名称
      form: {
        tid: "",
        size: 10,
        current: 1,
      },
      totalList: 0,
      isShowSub: false,
      tabIndex: 0,
      moduleList: [
        // {
        //   title: "全部",
        //   id: ""
        // },
        // {
        //   title: "营销模板",
        //   id: "5",
        //   children: [
        //     {
        //       title: "秒杀",
        //       id: "51"
        //     }
        //   ]
        // }
      ],
      selectIndex: 0,
      selectSecondIndex: -1,
      tableData: [],
      tableLoading: false,
      allShow: false, // 信息是否全部显示
      // 添加栏目弹窗
      addColumnDialog: false,
      // 删除栏目
      delColumnDialog: false,
      columnList: [],
      columnOfficialList: [],
      addModuleDialog: false,
      addModuleTitle: "创建模板",
      status: 1, // 表示创建  2.表示编辑模板
      moduleForm: {
        content: "",
        tid: "",
        mid: "",
      },
      moduleOForm: {
        // 官方添加模板
        tid: "",
        content: "",
      },
      type: "", //  0 个人，1系统，2官方，不传查全部
      delTid: "", // 删除栏目ID
      showModuleOffical: false,
      createLoading: false,
    };
  },
  mounted() {
    // var ModuleArr = [];
    // this.moduleList.forEach(item => {
    //   item["isExpand"] = true;
    //   ModuleArr.push(item);
    // });
    // this.moduleList = ModuleArr;
    if (this.$route.query && this.$route.query.type == '1') {
      // 模板选择弹窗的去创建模板跳转过来
      this.switchTab('4')
    }

    this.getDirList(); // 获取栏目列表
    this.getOfficilDirList(); // 获取官方栏目
    this.getModuleList(); // 获取左边栏目列表
  },
  methods: {
    switchOColumn(obj) {
      if (typeof obj != 'object') {
        obj = this.columnOfficialList.filter(cItem => {
          return cItem.tid == obj
        })
        obj = obj[0]
      }
      
      var varList = JSON.parse(obj.propList);
      var list = [];
      varList.forEach((vItem) => {
        list.push(vItem.valuie);
      });
      this.varilist = list;
    },
    insertX() {
      this.moduleOForm.content = this.moduleOForm.content + '回X退订'
    },
    handleCreateO() {
      this.showModuleOffical = true;
      
      var tid = this.form.tid;
      var columnOfficialList = this.columnOfficialList;
      this.moduleOForm.tid = tid;

      var selectObj = null;
      if (tid) {
        selectObj = columnOfficialList.filter(item => {
          return item.tid == tid
        })
      } else {
        selectObj = columnOfficialList[0]
        this.moduleOForm.tid = selectObj.tid;
      }
      this.switchOColumn(selectObj);
    },
    insertContent(myValue) {
      myValue = this.$ChineseVToEn(myValue, true)
      const smsContent = document.querySelector("#smsContent");
      var startPos = smsContent.selectionStart;
      var endPos = smsContent.selectionEnd;
      console.log("startPos:", startPos);

      if (startPos || startPos.selectionStart == "0" || startPos === 0) {
        smsContent.value =
          smsContent.value.substring(0, startPos) +
          myValue +
          smsContent.value.substring(endPos, smsContent.value.length);
        smsContent.selectionStart = startPos + myValue.length;
        smsContent.selectionEnd = startPos + myValue.length;
        smsContent.focus();
      } else {
        smsContent.value += myValue;
        smsContent.focus();
      }
      this.moduleOForm.content = smsContent.value;
    },
    submitForm() {
      this.getTemplateList(2);
    },
    resetForm() {
      this.formData = {
        content: "",
        officialTemplateId: "",
        approvalStatus: "",
        isBusinessApply: true,
      };
      this.getTemplateList(2);
    },
    // 获取模板列表 type: 0 个人创建，1.系统模板 2.官方模板的 全部搜索
    getTemplateList(type) {
      console.log("getTemplateList:==", type);
      this.tableLoading = true;
      var param = JSON.parse(JSON.stringify(this.form));
      if (type === 0 || type === 1 || type === 2) {
        param.type = type;
      }
      console.log("this.param:", param);
      if (this.tabIndex == 4) {
        // 官方模板申请
        param = { ...param, ...this.formData };
        param.content = this.$ChineseVToEn(param.content)
      } else if (this.tabIndex == 1) {
        // 官方模板
        param['isBusinessApply'] = false;
      }
      getTemplatesPage(param).then((res) => {
        if (res.code == "1") {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.totalList = res.data.total;
        }
      });
    },

    // 获取栏目列表
    getModuleList() {
      // type 类型： 0 个人，1系统，2官方，不传查全部
      var type = this.type;
      var param = {
        type: type || 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.moduleList = res.data;
          var orignListOfficial = [
            {
              title: "订单关怀模板",
              tid: "4",
              child: true,
              isExpand: false,
            },
            // {
            //   title: "自动化营销模板",
            //   tid: "5",
            //   child: true,
            //   isExpand: false,
            // },
          ]; // 官方模板
          var orignList = [
            {
              title: "全部",
              tid: "",
            },
          ];
          if (type === "" || type == "1") {
            orignList = [
              {
                title: "全部",
                tid: "",
              },
              {
                title: "物流模板",
                tid: "1",
                child: true,
                isExpand: false,
              },
              {
                title: "节日模板",
                tid: "2",
                child: true,
                isExpand: false,
              },
              {
                title: "营销模板",
                tid: "3",
                child: true,
                isExpand: false,
              },
            ];
          }
          if (type == "2" || type === "") {
            orignList = orignList.concat(orignListOfficial);
          }
          if (type == "2") {
            // 官方
            this.moduleList = orignList;
          } else {
            this.moduleList = orignList.concat(this.moduleList);
          }

          this.selectIndex = 0;
          this.selectSecondIndex = -1;
          this.getTemplateList(this.type);
        }
      });
    },
    // 创建官方申请模板
    handleOTemplate() {
      var content = this.moduleOForm.content;
      if (!content) {
        this.$message.warning("创建模板的短信内容不能为空哦！");
        return;
      }
      if (!this.moduleOForm.tid) {
        this.$message.warning("请选择栏目");
        return;
      }
      if (!(content.endsWith('回X退订') || content.endsWith('回x退订'))) {
         this.$message.warning("请插入'回X退订'");
        return;
      }

      let obj = this.columnOfficialList.filter((item) => {
        return item.tid == this.moduleOForm.tid;
      });
      obj = obj[0];
      var param = {
        content: this.$ChineseVToEn(content),
        tid: obj.tid,
        name: obj.title,
        modelType: obj.modelType,
        officialModelTypeId: obj.officialModelTypeId,
      };
      this.createLoading = true;
      addCustomerOfficialTemplate(param).then((res) => {
        this.createLoading = false;
        if (res.code == "1") {
          this.showModuleOffical = false;
          this.$message.success("创建模板成功！");
          this.getTemplateList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 创建模板
    handleTemplate() {
      if (!this.moduleForm.content) {
        this.$message.warning("创建模板的短信内容不能为空哦！");
        return;
      }
      if (!this.moduleForm.tid) {
        this.$message.warning("请选择栏目");
        return;
      }
      if (this.status == "1") {
        this.addModuleDialog = false;
        // 创建模板
        var param = this.moduleForm;
        createTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("创建模板成功！");
            this.getTemplateList();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.addModuleDialog = false;
        // 编辑模板
        var param = this.moduleForm;
        updateTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("编辑模板成功！");
            this.getTemplateList();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    // 获取自定义栏目列表
    getDirList() {
      var param = {
        type: 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.columnList = res.data;
        }
      });
    },

    // 获取官方栏目
    getOfficilDirList() {
      getOfficialTemplateDir().then((res) => {
        if (res.code == "1") {
          var list = res.data;
          // debugger
          list = list.filter(item => {
            return item.publicType == '4'
          })
          this.columnOfficialList = list[0].child;
          console.log(' this.columnOfficialList ',this.columnOfficialList)
        }
      });
    },

    // 添加栏目
    handleAddColumn() {
      if (!this.title) {
        this.$message.warning("栏目名称不能为空哦！");
      } else {
        this.addColumnDialog = false;
        var param = {
          title: this.title,
        };
        createAddColumn(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("添加栏目成功！");
            this.getModuleList();
            this.getDirList();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    /*
     * 删除模板
     * */
    handleDelete(index, row) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          if (this.tabIndex == '4') {
            // 删除官方申请模板
            var param = {
              id: row.mid,
            };
            delBusApplyTemplate(param).then((res) => {
              if (res.code == "1") {
                this.$message.success("删除成功");
                this.getTemplateList();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            var param = {
              mid: row.mid,
            };
            deleteTemplate(param).then((res) => {
              if (res.code == "1") {
                this.$message.success("删除成功");
                this.getTemplateList();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    // 显示创建模板
    showCreateModuleDialog(type, row) {
      if (type == 1) {
        this.addModuleTitle = "创建模板";
        this.status = 1;
        // var columnList = this.columnList;
        this.moduleForm = {
          content: "",
          // tid: this.form.tid || (columnList && columnList[0] && columnList[0].tid),
          tid: "",
        };
      } else {
        this.addModuleTitle = "编辑模板";
        this.status = 2;
        this.moduleForm = {
          content: row.content,
          tid: row.tid,
          mid: row.mid,
        };
      }
      this.addModuleDialog = true;
    },

    // 显示删除栏目
    showDelColumnDialog() {
      this.delTid = "";
      this.delColumnDialog = true;
    },
    // 删除栏目处理
    handleDelColumn() {
      this.delColumnDialog = false;
      var param = {
        tid: this.delTid,
      };
      deleteTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.$message.success("删除成功");
          this.getModuleList();
          // this.getTemplateList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 显示添加栏目
    showAddColumnDialog() {
      this.addColumnDialog = true;
    },
    // 切换模板
    switchTab(index) {
      // type 0 个人，1系统，2官方，不传查全部
      this.tabIndex = index;
      if (index == "1" || index == "4") {
        // 官方
        this.type = 2;
      } else if (index == "2") {
        // 系统
        this.type = 1;
      } else if (index == "3") {
        // 自定义
        this.type = 0;
      } else {
        // 全部
        this.type = "";
      }
      (this.form.size = 10), (this.form.current = 1);
      this.getModuleList();
    },
    handleSizeChange(val) {
      this.form.size = val;
      this.getTemplateList(this.type);
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.getTemplateList(this.type);
    },
    handleClickFirst(i, secondI) {
      var obj = this.moduleList[i];
      if (!secondI && secondI != "0") {
        if (obj.child) {
          this.selectIndex = -1;
          if (obj.isExpand) {
            obj.isExpand = false;
          } else {
            this.getChildList(i);
          }
        } else {
          this.selectIndex = i;
          this.selectSecondIndex = -1;
          this.form = {
            tid: obj.tid,
            size: 10,
            current: 1,
          };
          var type = null;
          if (obj.tid == "") {
            type = this.type;
          }
          this.getTemplateList(type);
        }
      } else {
        this.selectSecondIndex = secondI;
        this.selectIndex = -1;
        this.form = {
          tid: obj.children[secondI].tid,
          size: 10,
          current: 1,
        };

        this.getTemplateList(type);
      }
    },

    // 获取子栏目
    getChildList(i) {
      // publicType 1表示物流模板 2表示节日模板，3表示营销模板
      var obj = this.moduleList[i];

      var param = {
        publicType: obj.tid,
      };
      getTemplateChild(param).then((res) => {
        if (res.code == "1") {
          obj.isExpand = !obj.isExpand;
          obj.children = res.data;
          this.$set(this.moduleList, i, obj);
        }
      });
    },
  },

  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
};
</script>
<style scoped lang="scss">
.operation-btn .el-button{
  padding: 0!important;
  width: 32px;
}
.footTips {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding-left: 12px;
  height: 28px;
  background: rgba(255, 250, 238, 1);
  // border: 1px solid rgba(255, 185, 94, 1);
  border-radius: 2px;
  color: #333;
  font-size: 13px;
}
.button-status5 {
  background-color: #fff;
  border: 1px solid #fe4d45;
  font-size: 14px;
  color: #fe4d45;
  &:hover {
    background-color: #fe4d45;
    border: 1px solid #fe4d45;
    color: #fff;
  }
  &:active {
    background-color: #fe4d45;
    border: #fe4d45;
    color: #fff;
  }
}
.tip-box{
  padding-top: 10px;
  p{
    margin-bottom: 5px;
  }
}
.insert-dom{
  display: inline-block;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  // margin-top: 5px;
  cursor: pointer;
  line-height: 15px;
}
.variable-box {
  .v-item {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    color: #fff;
    display: inline-block;
    margin-right: 10px;
    padding: 5px;
    border-radius: 4px;
    padding-top: 5px;
    margin-bottom: 5px;
    line-height: 15px;
  }
}
.search-box {
  padding-top: 17px;
  padding-bottom: 10px;
  .btn_group {
    text-align: center;
  }
}
.theTitle {
  min-width: 980px;
  height: 57px;
  line-height: 57px;
  padding: 0;
  color: #2e3458;
  font-weight: bold;
  margin: 20px;
  border: 1px solid rgba(230, 230, 230, 1);
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}
.btn-line {
  margin-top: 20px;
  .el-button {
    width: 98px;
    height: 32px;
  }
}
.order-line {
  span {
    display: inline-block;
    width: 72px;
    text-align: right;
  }
  .el-input {
    display: inline-block;
    width: 470px;
  }
  .el-textarea {
    width: 440px;
    vertical-align: top;
  }
}
.operation {
  width: 60px;
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
.content-box {
  min-width: 1046px;
  background-color: #fff;
  border-radius: 6px;
  -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 24px 28px;
  margin: 20px;
  .b1 {
    width: 98px;
    height: 32px;
    font-size: 14px;
    border-radius: 3px;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    color: #666666;
    font-size: 14px;
    border-radius: 3px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .tab-line {
    border-bottom: 1px solid #dddddd;
    .tab-item {
      font-size: 14px;
      color: #666;
      display: inline-block;
      width: 106px;
      height: 36px;
      line-height: 36px;
      box-sizing: border-box;
      text-align: center;
      border: 1px solid #dddddd;
      border-bottom: none;
      margin-right: 2px;
      border-radius: 2px 2px 0 0;
      cursor: pointer;
      &.active {
        font-weight: 500;
        color: #fe4d45;
        border-top-width: 2px;
        border-top-color: #fe4d45;
        position: relative;
        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 2px;
          position: absolute;
          left: 0;
          bottom: -2px;
          background-color: #fff;
        }
      }
    }
  }
}
.content-table {
  padding-top: 17px;
  // position: relative;
  // height: 722px;
  /** 左边菜单栏 */
  .left-menu {
    vertical-align: text-top;
    display: inline-block;
    font-size: 14px;
    color: #333333;
    width: 220px;
    border: 1px solid #eeeeee;
    padding: 12px 11px 12px 8px;
    box-sizing: border-box;
    // position: absolute;
    // top: 0;
    // left: 0;
    height: 722px;
    overflow: auto;
    p {
      margin: 0;
    }
    .first-menu {
      cursor: pointer;
      .title {
        padding-left: 24px;
        position: relative;
        line-height: 28px;
        display: inline-block;
        width: 195px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      i {
        color: #ccc;
        position: absolute;
        left: 8px;
        top: 50%;
        transform: translateY(-50%);
      }
      &.active {
        color: #fe4d45;
        background-color: #f6f6f6;
      }
    }
    .second-menu {
      font-size: 14px;
      color: #999;
      transition: height 0.3s linear;
      overflow: hidden;
      p {
        padding-left: 34px;
        line-height: 28px;
        cursor: pointer;
        &.active {
          color: #fe4d45;
          background-color: #f6f6f6;
        }
      }
    }
  }
  /** 右边表格 */
  .table-content {
    display: inline-block;
    vertical-align: text-top;
    margin-left: 20px;
    width: calc(100% - 250px);
    // height: 200px;
    // position: absolute;
    // right: 0;
    // left: 240px;
    .table-message {
      cursor: pointer;
      margin-left: 8px;
    }
    .module-content {
      // width: 430px;
      max-width: 430px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.pagination {
  text-align: right;
  margin-top: 20px;
}
.btn-group {
  text-align: right;
  margin-top: 20px;
  .el-button {
    width: 98px;
  }
}
</style>